import { Box, Button, Grid, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import Services from '../Components/Services';
import LetsTalk from '../Components/LetsTalk';
import StickyCardStack from '../Components/HorizontalScrollCards';
import HorizontalScrollCards from '../Components/HorizontalScrollCards';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import SEO from '../Components/SEO/SEO.tsx';




const servicesData = [
    {
        title: "Brand Design & UI/UX",
        showtitle: "Brand Design & UI/UX",
        navigateurl: "brand-design-uiux",
        metatitle: "Brand Design & UI/UX Company Australia | App Gallery",
        metadescription: "Looking for a Brand Design & UI/UX company in Australia? App Gallery builds tailored software solutions for businesses in Sydney, Melbourne and across Australia.",
        overview: "Bold brand identities fused with high-impact UI/UX design to create experiences that don’t just look exceptional, but perform. Every interaction is engineered to captivate, convert, and scale across digital ecosystems. Strategy meets precision to deliver clarity, consistency, and measurable growth. Built to stand out, designed to lead.",
        overviewLine: "Where strategy meets striking visuals and seamless user journeys to elevate perception, boost engagement, and drive lasting impact.",
        scrollLine: "How We Approach Brand Design & UI/UX Design for Growing Products © How We Approach Brand Design & UI/UX Design for Growing Products ©",
        features: [
            {
                title: "Deep Discovery & Market Intelligence",
                description: "Every engagement begins with understanding the product, audience behavior, and competitive landscape. This includes stakeholder workshops, user research, and positioning audits to uncover gaps, opportunities, and differentiators.",
            },
            {
                title: "Strategic Brand Foundation",
                description: "A clear brand strategy is defined—covering positioning, personality, tone of voice, and visual direction. The goal is to create a distinct identity that resonates with the target audience while remaining flexible for future growth",
            },
            {
                title: "Experience Architecture (UX)",
                description: "User journeys are mapped with precision, focusing on usability, clarity, and conversion. Information architecture, wireframes, and interaction flows are designed to remove friction and guide users effortlessly toward key actions.",
            },
            {
                title: "Visual System & UI Design",
                description: "Interfaces are crafted using scalable design systems—ensuring consistency across platforms. Typography, color systems, components, and micro-interactions are aligned with the brand to deliver a cohesive and premium experience.",
            },
            {
                title: "Validation & Iteration",
                description: "Design decisions are tested through prototypes, usability testing, and data feedback loops. Continuous refinement ensures the product evolves based on real user behavior, not assumptions.",
            },
            {
                title: "Scalable Implementation",
                description: "Final outputs are delivered with developer-ready assets and structured design systems, enabling seamless handoff and long-term scalability across web, mobile, and future digital touchpoints.",
            },

        ],
        processes: [
            { title: "Insight (Research + Competitors)", discription: "In-depth exploration of user behavior, market trends, and competitive landscape to uncover actionable insights. This stage identifies gaps, opportunities, and strategic direction to ensure every decision is grounded in real data." },
            { title: "Brand Strategy & Foundations", discription: "Definition of a clear and compelling brand—positioning, personality, tone, and visual direction. Establishes a strong foundation that ensures consistency, differentiation, and emotional connection across all touchpoints." },
            { title: "UX Architecture", discription: "Structured mapping of user journeys, flows, and information architecture to create intuitive and frictionless experiences. Focused on usability, clarity, and guiding users toward meaningful actions." },
            { title: "Wireframing & Structure", discription: "Creation of low-fidelity layouts to define content hierarchy, layout logic, and interaction patterns. This stage builds the blueprint of the product before visual execution begins." },
            { title: "UI Design & Visual Systems", discription: "Design of high-impact interfaces supported by scalable design systems. Combines branding, typography, color, and components to deliver a cohesive, visually engaging, and consistent user experience." },
            { title: "Testing & Iteration", discription: "Continuous validation through usability testing and feedback loops to refine and optimize performance. Ensures the final product is not only functional but effective and user-approved." },
        ],
        faq: [
            {
                title: "Deep Discovery & Market Intelligence",
                description: "Every engagement begins with understanding the product, audience behavior, and competitive landscape. This includes stakeholder workshops, user research, and positioning audits to uncover gaps, opportunities, and differentiators.",
            },
            {
                title: "Strategic Brand Foundation",
                description: "A clear brand strategy is defined—covering positioning, personality, tone of voice, and visual direction. The goal is to create a distinct identity that resonates with the target audience while remaining flexible for future growth",
            },
            {
                title: "Experience Architecture (UX)",
                description: "User journeys are mapped with precision, focusing on usability, clarity, and conversion. Information architecture, wireframes, and interaction flows are designed to remove friction and guide users effortlessly toward key actions.",
            },
            {
                title: "Visual System & UI Design",
                description: "Interfaces are crafted using scalable design systems—ensuring consistency across platforms. Typography, color systems, components, and micro-interactions are aligned with the brand to deliver a cohesive and premium experience.",
            },
            {
                title: "Validation & Iteration",
                description: "Design decisions are tested through prototypes, usability testing, and data feedback loops. Continuous refinement ensures the product evolves based on real user behavior, not assumptions.",
            },
            {
                title: "Scalable Implementation",
                description: "Final outputs are delivered with developer-ready assets and structured design systems, enabling seamless handoff and long-term scalability across web, mobile, and future digital touchpoints.",
            },

        ],
    },
    {
        title: "Website & Web Platform",
        showtitle: "Website & Web Platform",
        navigateurl: "website-web-platform",
        metatitle: "Website & Web Platform Company Australia | App Gallery",
        metadescription: "Looking for a custom software development company in Australia? App Gallery builds tailored software solutions for businesses in Sydney, Melbourne and across Australia.",
        overview: "Our Website & Web Platform development services focus on creating high-performance, scalable, and user-friendly digital experiences that help businesses grow online. We specialize in building responsive websites, custom web applications, and dynamic platforms tailored to your business needs. From corporate websites and eCommerce platforms to complex dashboards and client portals, we combine modern design, robust development, and seamless functionality to deliver fast, secure, and engaging web solutions",
        overviewLine: "We design and develop scalable, high-performance websites and web applications that deliver seamless user experiences, strong functionality, and business-driven digital solutions.",
        features: [
            {
                title: "Business Understanding",
                description: "We begin by understanding your brand, target audience, and business goals to ensure the website aligns with your vision and objectives.",
            },
            {
                title: "Requirement & Feature Planning",
                description: "We identify key features, functionalities, and user journeys required to create a meaningful and effective web experience.",
            },
            {
                title: "UI/UX Strategy",
                description: "We focus on intuitive design and user experience, ensuring your platform is visually appealing, easy to navigate, and conversion-driven.",
            },
            {
                title: "Custom Development",
                description: "We develop tailored web solutions using modern technologies, ensuring flexibility, performance, and reliability.",
            },
            {
                title: "Performance & Scalability Focus",
                description: "We build platforms optimized for speed, responsiveness, and scalability to handle growth and high user traffic.",
            },
            {
                title: "Deployment & Continuous Improvement",
                description: "We ensure smooth deployment and provide ongoing optimization, updates, and enhancements to keep your platform competitive.",
            },
        ],

        processes: [
            {
                title: "Requirement Analysis",
                discription: "Define business goals, features, and technical requirements to establish a clear roadmap for development.",
            },
            {
                title: "Wireframing & Design",
                discription: "Create layouts, UI designs, and user flows to visualize structure and user experience before development.",
            },
            {
                title: "Development",
                discription: "Build frontend and backend systems using clean, scalable architecture and modern technologies.",
            },
            {
                title: "Testing & QA",
                discription: "Ensure functionality, responsiveness, and security across devices through thorough testing.",
            },
            {
                title: "Deployment",
                discription: "Launch the platform with proper configuration, optimization, and monitoring for performance.",
            },
            {
                title: "Maintenance & Support",
                discription: "Provide continuous updates, performance improvements, and issue resolution to keep the platform running smoothly.",
            },
        ],
        faq: [
            {
                title: "What types of websites do you develop?",
                description: "We develop corporate websites, eCommerce platforms, custom web applications, dashboards, and client portals tailored to your needs.",
            },
            {
                title: "Will my website be mobile-friendly?",
                description: "Yes, all our websites are fully responsive and optimized for mobile, tablet, and desktop devices.",
            },
            {
                title: "Can you redesign an existing website?",
                description: "Absolutely. We can revamp your existing website to improve design, performance, and user experience.",
            },
            {
                title: "What technologies do you use?",
                description: "We use modern frameworks and technologies such as React, Angular, Node.js, and other scalable solutions based on project requirements.",
            },
            {
                title: "Do you provide ongoing maintenance?",
                description: "Yes, we offer continuous support, updates, and performance optimization after deployment.",
            },
            {
                title: "How long does it take to build a website?",
                description: "The timeline depends on the complexity and features, but we ensure timely delivery without compromising quality.",
            },
        ],
    },
    {
        title: "Mobile App & IoT",
        showtitle: "Mobile App Development Services",
        navigateurl: "mobile-app-development-services",
        metatitle: "Mobile App Development Services Australia | App Gallery",
        metadescription: "App Gallery is a trusted mobile app development company in Australia, delivering custom iOS and Android app solutions in Sydney and Melbourne.",
        overview: "Our Mobile Apps & IoT services are focused on building smart, connected, and user-centric digital solutions that bridge the gap between devices and users. We develop high-performance mobile applications for Android and iOS, along with IoT-enabled systems that allow real-time data monitoring, automation, and control. From consumer-facing apps to enterprise mobility solutions and connected device ecosystems, we combine intuitive design, robust development, and seamless integration to deliver innovative and scalable experiences.",
        overviewLine: "We build intelligent mobile applications and IoT solutions that connect users, devices, and data in real time to deliver seamless, automated, and smart digital experiences.",
        features: [
            {
                title: "Business Understanding",
                description: "We begin by understanding your business objectives, target users, and the role mobile and IoT solutions will play in your ecosystem.",
            },
            {
                title: "Use Case & Device Planning",
                description: "We identify key use cases, user interactions, and IoT device requirements to ensure a practical and impactful solution.",
            },
            {
                title: "Architecture & Connectivity Strategy",
                description: "We design system architecture, focusing on secure communication between mobile apps, devices, and cloud infrastructure.",
            },
            {
                title: "Custom App & IoT Development",
                description: "We develop tailored mobile applications and IoT systems using modern technologies, ensuring performance, reliability, and flexibility.",
            },
            {
                title: "Scalability & Security Focus",
                description: "We build solutions that are scalable and secure, capable of handling growing users, devices, and data streams.",
            },
            {
                title: "Integration & Continuous Optimization",
                description: "We integrate solutions seamlessly into your workflows and continuously optimize performance, usability, and device communication.",
            },
        ],

        processes: [
            {
                title: "Requirement Analysis",
                discription: "Understand app features, device requirements, and business goals to define a clear development roadmap.",
            },
            {
                title: "UI/UX Design",
                discription: "Create intuitive and engaging mobile app interfaces focused on usability and user experience.",
            },
            {
                title: "App & IoT Development",
                discription: "Build mobile applications and integrate them with IoT devices and cloud systems for seamless operation.",
            },
            {
                title: "Testing & QA",
                discription: "Ensure app performance, device connectivity, and data accuracy through thorough testing.",
            },
            {
                title: "Deployment",
                discription: "Launch applications on app stores and configure IoT environments for real-world use.",
            },
            {
                title: "Monitoring & Maintenance",
                discription: "Track performance, resolve issues, and continuously enhance features and system efficiency.",
            },
        ],

        faq: [
            {
                title: "What types of mobile apps do you develop?",
                description: "We develop Android, iOS, and cross-platform apps like Flutter and React Native for both consumer and enterprise use cases.",
            },
            {
                title: "Can you integrate mobile apps with IoT devices?",
                description: "Yes, we specialize in connecting mobile applications with IoT devices for real-time monitoring, control, and automation.",
            },
            {
                title: "Which IoT solutions do you support?",
                description: "We work with various IoT applications including smart devices, industrial IoT, home automation, and connected systems.",
            },
            {
                title: "How do you ensure data security in IoT systems?",
                description: "We implement secure communication protocols, encryption, and best practices to protect data across devices and platforms.",
            },
            {
                title: "Do you provide post-launch support?",
                description: "Yes, we offer continuous monitoring, updates, and improvements for both mobile apps and IoT systems.",
            },
            {
                title: "How long does it take to develop a mobile app or IoT solution?",
                description: "The timeline depends on complexity, features, and integrations, but we ensure efficient delivery with high-quality standards.",
            },
        ],
    },
    {
        title: "CRM & Custom Software",
        showtitle: "Custom Software Development Services",
        navigateurl: "custom-software-development-services",
        metatitle: "Custom Software Development Company Australia | App Gallery",
        metadescription: "Looking for a custom software development company in Australia? App Gallery builds tailored software solutions for businesses in Sydney, Melbourne and across Australia.",
        overview: "Our CRM & Customer Software solutions are designed to help businesses manage, engage, and grow their customer base more effectively. We develop customized CRM systems and customer-centric platforms that streamline sales, automate workflows, and enhance customer interactions. From lead management and sales tracking to customer support systems and analytics dashboards, we build scalable and intuitive solutions that centralize data, improve efficiency, and drive better customer relationships.",
        overviewLine: "We develop intelligent CRM systems and customer management software that streamline sales, improve customer relationships, and automate business workflows for better efficiency and growth.",
        features: [
            {
                title: "Business Understanding",
                description: "We begin by understanding your customer journey, sales processes, and business goals to ensure the solution aligns perfectly with your operations.",
            },
            {
                title: "Process & Workflow Mapping",
                description: "We analyze your existing workflows and configure the system to automate, simplify, and enhance your customer management processes.",
            },
            {
                title: "Data Strategy & Structuring",
                description: "We define how customer data is captured, organized, and utilized within the system to ensure accuracy and actionable insights.",
            },
            {
                title: "Custom CRM Configuration",
                description: "We tailor the CRM with custom modules, dashboards, and features based on your specific business requirements.",
            },
            {
                title: "Scalability & Integration Focus",
                description: "We ensure the system scales with your business and integrates seamlessly with tools like email, marketing platforms, and third-party services.",
            },
            {
                title: "Optimization & Continuous Improvement",
                description: "We continuously enhance the system by monitoring performance, gathering feedback, and introducing improvements for better ROI.",
            },
        ],

        processes: [
            {
                title: "Requirement Analysis",
                discription: "Understand customer management needs, features, and business goals to define a clear CRM roadmap.",
            },
            {
                title: "System Design",
                discription: "Plan CRM structure, workflows, and user roles to ensure efficient and organized operations.",
            },
            {
                title: "Development",
                discription: "Build customized CRM and customer software solutions tailored to business requirements.",
            },
            {
                title: "Testing & QA",
                discription: "Ensure data accuracy, system performance, and reliability through thorough testing.",
            },
            {
                title: "Deployment",
                discription: "Implement the system with proper setup, configuration, and user onboarding.",
            },
            {
                title: "Maintenance & Support",
                discription: "Provide continuous updates, improvements, and technical support for long-term success.",
            },
        ],

        faq: [
            {
                title: "What is a CRM system and why is it important?",
                description: "A CRM (Customer Relationship Management) system helps businesses manage customer data, track interactions, and improve relationships, leading to better sales and customer retention.",
            },
            {
                title: "Can you customize the CRM according to our business?",
                description: "Yes, we develop fully customized CRM solutions tailored to your workflows, industry, and specific requirements.",
            },
            {
                title: "Can CRM systems integrate with other tools?",
                description: "Absolutely. Our CRM solutions can integrate with email systems, marketing tools, payment gateways, and other business applications.",
            },
            {
                title: "Is the CRM scalable for future growth?",
                description: "Yes, we design CRM systems that can scale with your business as your customer base and operations expand.",
            },
            {
                title: "Do you provide training and support?",
                description: "Yes, we offer onboarding, training, and continuous support to ensure smooth adoption and usage.",
            },
            {
                title: "How secure is customer data in your CRM solutions?",
                description: "We implement strong security measures including data encryption, access control, and secure storage to protect customer information.",
            },
        ],
    },
    {
        title: "AI & Machine Learning",
        showtitle: "AI Automation and Machine Learning Services",
        navigateurl: "ai-automation-and-machine-learning-services",
        metatitle: "AI Automation & Machine Learning Services in Australia | App Gallery",
        metadescription: "App Gallery provides AI automation and machine learning services in Sydney and Melbourne, Australia. Automate workflows, improve efficiency, and accelerate business growth with smart AI solutions.",
        overview: "Our AI & Machine Learning services are designed to transform raw data into intelligent insights and automated solutions that drive business growth. We specialize in advanced stock analysis for smarter investment decisions, conversational AI like Ask Mr. Wolf for instant query resolution, AI-powered mystery shopping report QA to ensure accuracy and compliance, and custom chatbot development for MM clients. By combining predictive analytics, natural language processing, and automation, we help businesses operate smarter, faster, and more efficiently.",
        overviewLine: "We deliver AI & Machine Learning solutions that turn data into smart insights and automation, including stock analysis, conversational AI, report QA, and custom chatbots to help businesses work faster and smarter.",
        features: [
            {
                title: "Business Understanding",
                description: "We begin by deeply understanding your business goals, challenges, and vision to ensure our AI solutions align perfectly with your objectives.",
            },
            {
                title: "Use Case Identification",
                description: "We identify high-impact opportunities where AI can deliver measurable value, focusing on areas that improve efficiency, accuracy, and decision-making.",
            },
            {
                title: "Data-Driven Strategy",
                description: "We analyze available data and define a strategic roadmap, ensuring the right data is used to power intelligent and reliable AI models.",
            },
            {
                title: "Advanced Model Engineering",
                description: "We design and develop AI models using advanced techniques such as deep learning, reinforcement learning, ensemble models, and transformer-based architectures for enhanced accuracy and performance.",
            },
            {
                title: "NLP & Conversational Intelligence",
                description: "We implement state-of-the-art natural language processing techniques including intent recognition, sentiment analysis, context handling, and large language model (LLM) integration to build intelligent conversational systems.",
            },
            {
                title: "Intelligent Automation & Workflow Optimization",
                description: "We integrate AI-driven automation to streamline complex workflows, reduce manual intervention, and improve operational efficiency using event-driven and rule-based systems.",
            },
            {
                title: "Scalable Architecture & MLOps",
                description: "We build scalable AI systems using cloud-native architectures, along with MLOps practices such as model versioning, CI/CD pipelines for ML, automated retraining, and monitoring for continuous performance improvement.",
            },
            {
                title: "Seamless Integration & Optimization",
                description: "We integrate AI solutions smoothly into your existing workflows and continuously monitor, fine-tune, and optimize performance to maximize ROI, accuracy, and usability.",
            },
        ],

        processe: [
            {
                title: "Requirement Analysis",
                discription: "Understand business goals, data availability, and expected outcomes to define the AI strategy.",
            },
            {
                title: "Data Collection & Preparation",
                discription: "Clean, structure, and validate datasets to ensure they are ready for model training and analysis.",
            },
            {
                title: "Model Development",
                discription: "Build and train AI/ML models tailored to use cases such as stock prediction, chatbot intelligence, and automation.",
            },
            {
                title: "Testing & Validation",
                discription: "Evaluate model accuracy, performance, and reliability using various validation techniques.",
            },
            {
                title: "Deployment & Integration",
                discription: "Implement AI solutions into existing systems with minimal disruption and seamless integration.",
            },
            {
                title: "Monitoring & Optimization",
                discription: "Continuously track performance, retrain models, and optimize results for better accuracy and efficiency.",
            },
        ],

        faq: [
            {
                title: "What industries can benefit from your AI solutions?",
                description: "Our solutions are adaptable across finance, retail, customer service, and market research, especially where data-driven decisions and automation are critical.",
            },
            {
                title: "How accurate are your AI systems?",
                description: "Our models use advanced algorithms and continuous learning techniques to deliver high accuracy, with performance improving over time as more data becomes available.",
            },
            {
                title: "What technologies do you use?",
                description: "We use a combination of machine learning, deep learning, NLP, LLMs, and cloud-based AI frameworks depending on project requirements.",
            },
            {
                title: "Can your AI solutions handle real-time data?",
                description: "Yes, we design systems capable of processing and analyzing real-time data for instant insights and decision-making.",
            },
            {
                title: "Can chatbots and AI systems be customized?",
                description: "Absolutely. All our AI solutions are fully customizable based on your business workflows, data, and integration needs.",
            },
            {
                title: "Do you provide ongoing support?",
                description: "Yes, we offer continuous monitoring, updates, retraining, and optimization to ensure long-term performance and reliability.",
            },
        ],
    },
    {
        title: "Cloud Computing & DevOps",
        showtitle: "Cloud Computing & DevOps",
        navigateurl: "cloud-computing-devops",
        metatitle: "Cloud Computing & DevOps Company Australia | App Gallery",
        metadescription: "Looking for a custom software development company in Australia? App Gallery builds tailored software solutions for businesses in Sydney, Melbourne and across Australia.",
        overview: "Our Cloud Computing & DevOps services enable businesses to build, deploy, and manage applications with speed, scalability, and reliability. We help organizations migrate to the cloud, optimize infrastructure, and implement DevOps practices that streamline development and operations. From cloud architecture design and CI/CD pipeline setup to infrastructure automation and monitoring, we ensure faster releases, reduced downtime, and improved system performance while maintaining security and cost efficiency.",
        overviewLine: "We provide scalable cloud solutions and DevOps services that ensure faster deployments, high availability, and secure, efficient infrastructure management for modern digital businesses.",
        features: [
            {
                title: "Business & Infrastructure Assessment",
                description: "We begin by understanding your current infrastructure, business goals, and technical challenges to define the right cloud and DevOps strategy.",
            },
            {
                title: "Cloud Strategy & Planning",
                description: "We identify the best cloud approach (public, private, or hybrid) and create a roadmap for migration, scalability, and cost optimization.",
            },
            {
                title: "Architecture Design",
                description: "We design secure, scalable, and high-performing cloud architectures tailored to your application and workload requirements.",
            },
            {
                title: "DevOps Implementation",
                description: "We implement DevOps practices including CI/CD pipelines, automation, and version control to accelerate development and deployment cycles.",
            },
            {
                title: "Security & Compliance Focus",
                description: "We ensure your infrastructure follows best practices for security, data protection, and compliance standards.",
            },
            {
                title: "Monitoring & Continuous Optimization",
                description: "We continuously monitor system performance, optimize resources, and improve processes to ensure reliability and efficiency.",
            },
        ],

        processe: [
            {
                title: "Requirement Analysis",
                discription: "Assess infrastructure, applications, and business needs to define a clear cloud strategy.",
            },
            {
                title: "Cloud Setup & Migration",
                discription: "Move applications and data to cloud environments with minimal downtime and secure execution.",
            },
            {
                title: "CI/CD Pipeline Setup",
                discription: "Automate build, test, and deployment processes for faster and more reliable releases.",
            },
            {
                title: "Infrastructure Automation",
                discription: "Use tools to manage, scale, and optimize infrastructure efficiently.",
            },
            {
                title: "Testing & Deployment",
                discription: "Ensure smooth, error-free application releases across environments.",
            },
            {
                title: "Monitoring & Maintenance",
                discription: "Track system performance, manage uptime, and continuously optimize costs and efficiency.",
            },
        ],

        faq: [
            {
                title: "What is Cloud Computing and DevOps?",
                description: "Cloud Computing provides scalable infrastructure over the internet, while DevOps is a set of practices that automate and improve software development and deployment processes.",
            },
            {
                title: "Which cloud platforms do you work with?",
                description: "We work with major cloud providers such as AWS, Azure, and Google Cloud, based on your project requirements.",
            },
            {
                title: "Can you migrate our existing system to the cloud?",
                description: "Yes, we handle end-to-end cloud migration with minimal downtime and strong data security practices.",
            },
            {
                title: "What are CI/CD pipelines?",
                description: "CI/CD pipelines automate the process of building, testing, and deploying applications, enabling faster and more reliable releases.",
            },
            {
                title: "How do you ensure system security?",
                description: "We implement best practices including access control, encryption, monitoring, and compliance standards to secure your infrastructure.",
            },
            {
                title: "Do you provide ongoing support?",
                description: "Yes, we offer continuous monitoring, optimization, and maintenance to ensure your systems run smoothly and efficiently.",
            },
        ],
    },
    {
        title: "SEO & Search Marketing",
        showtitle: "SEO Services",
        navigateurl: "seo-services",
        metatitle: "SEO Services in Australia | Professional SEO Agency | App Gallery",
        metadescription: "App Gallery provides professional SEO services in Sydney and Melbourne, helping businesses improve Google rankings, increase organic traffic, generate quality leads, and grow online.",
        overview: "Our SEO and Search Marketing services are focused on helping your business get found by customers who are already searching. We combine technical SEO, content strategy, local search and ethical link building to improve rankings, grow organic traffic and generate qualified leads. Because our team also designs and builds websites, web platforms and mobile apps, we can fix technical issues directly and build search performance on solid foundations, with clear reporting you can act on.",
        overviewLine: "We improve your visibility in search so the right customers find your business and take action.",
        features: [
            {
                title: "Technical SEO",
                description: "We improve site speed, crawlability, indexation, structured data and mobile usability so search engines can access and understand every important page.",
            },
            {
                title: "On-Page SEO",
                description: "We map keywords to pages and optimise titles, descriptions, headings and internal links so each page has a clear search purpose.",
            },
            {
                title: "Content Strategy",
                description: "We research the topics your customers search for and create service pages and articles that answer them and support conversions.",
            },
            {
                title: "Local SEO",
                description: "We optimise your Google Business Profile, local citations and location pages to improve visibility across Melbourne, Victoria and Australia.",
            },
            {
                title: "Authority & Link Building",
                description: "We build trust with search engines through ethical outreach, digital PR and relevant partnerships.",
            },
            {
                title: "Analytics & Continuous Optimisation",
                description: "We set up GA4, Google Search Console and conversion tracking, report every month, and refine the strategy based on results.",
            },
        ],

        processes: [
            {
                title: "Discovery & Goals",
                discription: "Understand your business, customers, competitors and the outcomes you want from search.",
            },
            {
                title: "SEO Audit",
                discription: "Review technical health, content and competitors to find where visibility is being lost.",
            },
            {
                title: "Strategy & Roadmap",
                discription: "Prioritise keywords, content and fixes by impact and effort in a clear roadmap.",
            },
            {
                title: "Implementation",
                discription: "Deliver technical fixes and on-page improvements with our development team.",
            },
            {
                title: "Content & Authority Building",
                discription: "Publish new content and earn quality links to grow rankings.",
            },
            {
                title: "Reporting & Optimisation",
                discription: "Track rankings, traffic and leads every month and continuously improve results.",
            },
        ],

        faq: [
            {
                title: "How long does SEO take to show results?",
                description: "Most businesses see early technical and ranking improvements within 8 to 12 weeks, with meaningful traffic and lead growth typically building over 4 to 6 months. Timelines depend on competition, site health and content.",
            },
            {
                title: "Do you guarantee first-page rankings?",
                description: "No. Nobody can honestly guarantee rankings, because search engines control them. We commit to a clear strategy, quality execution and transparent reporting against agreed goals.",
            },
            {
                title: "Can you fix technical problems on my website yourselves?",
                description: "Yes. Our development team can implement technical SEO fixes directly, including speed, structure and schema, which saves time and back-and-forth.",
            },
            {
                title: "We are about to rebuild our website. Can you help protect our SEO?",
                description: "Yes. We plan redirects, URL structure, metadata and tracking before launch, so you do not lose existing rankings.",
            },
            {
                title: "Do you work with businesses outside Melbourne?",
                description: "Yes. We are based in Melbourne and work with clients across Australia.",
            },
            {
                title: "What does SEO cost?",
                description: "Pricing depends on scope, competition and goals. We offer a one-off audit and ongoing monthly retainers. Contact us for a tailored proposal.",
            },
        ],
    },
    {
        title: "Social Media Marketing",
        showtitle: "Social Media Marketing Services",
        navigateurl: "social-media-marketing-services",
        metatitle: "Social Media Marketing Agency in Australia | App Gallery",
        metadescription: "App Gallery is a leading social media marketing agency in Sydney and Melbourne, helping businesses boost brand awareness, increase engagement, reach target audiences, and generate quality leads.",
        overview: "Our Social Media Marketing services are focused on building your brand and turning social channels into a consistent source of attention, trust and enquiries. We combine strategy, content creation, community management, profile optimisation and paid social advertising across the platforms your audience uses. Because we also design brands and build websites and apps, your social presence connects properly to your product, your site and your tracking, with monthly reporting that shows what is working.",
        overviewLine: "We plan, create and manage social media that builds your brand, engages your audience and drives results.",
        features: [
            {
                title: "Strategy & Brand Voice",
                description: "We research your audience and competitors, choose the right platforms and define content pillars and a consistent brand voice.",
            },
            {
                title: "Content Creation",
                description: "We create post copy, graphics, carousels and short-form video concepts designed for each platform and aligned with your brand.",
            },
            {
                title: "Publishing & Community Management",
                description: "We manage a monthly content calendar, schedule posts, and respond to comments and messages on your behalf.",
            },
            {
                title: "Profile Optimisation (SMO)",
                description: "We optimise bios, keywords, links and branding so your channels are easy to find and convert.",
            },
            {
                title: "Paid Social Advertising",
                description: "We run targeted campaigns on Meta, LinkedIn and other platforms with creative testing and conversion tracking.",
            },
            {
                title: "Analytics & Continuous Optimisation",
                description: "We report monthly on reach, engagement, traffic and leads, and refine content, timing and spend based on results.",
            },
        ],

        processes: [
            {
                title: "Discovery & Audit",
                discription: "Understand your business, audience and goals, and review your current channels and competitors.",
            },
            {
                title: "Strategy & Planning",
                discription: "Define platforms, content pillars, tone of voice, posting cadence and success metrics.",
            },
            {
                title: "Content Creation",
                discription: "Produce on-brand content aligned with your campaigns and website.",
            },
            {
                title: "Approval & Publishing",
                discription: "Share a monthly calendar for approval, then schedule and publish.",
            },
            {
                title: "Engagement & Community",
                discription: "Respond to your audience, manage enquiries and build relationships.",
            },
            {
                title: "Reporting & Optimisation",
                discription: "Review results every month and adjust content, timing and spend.",
            },
        ],

        faq: [
            {
                title: "Which social platforms should my business be on?",
                description: "It depends on your audience and goals. B2B and professional services usually lead with LinkedIn, while consumer and lifestyle brands often perform best on Instagram, Facebook and TikTok. We recommend a focused mix rather than being everywhere.",
            },
            {
                title: "What is the difference between social media marketing and social media optimisation (SMO)?",
                description: "Social media marketing covers the full program: strategy, content, community and advertising. Social media optimisation is the part that improves how your profiles, content and posting work, so your channels get found, engage people and drive traffic.",
            },
            {
                title: "Do you manage paid advertising as well as organic content?",
                description: "Yes. We can manage organic social, paid social, or both together, with budgets and results reported separately.",
            },
            {
                title: "How often will you post for us?",
                description: "Cadence depends on your goals, platforms and budget. Most clients start with two to five posts per week per platform, which we refine based on performance.",
            },
            {
                title: "Do we need to approve content before it goes live?",
                description: "Yes, if you would like to. Our standard process includes a monthly content calendar for your review and approval before publishing.",
            },
            {
                title: "How long until we see results?",
                description: "Engagement and reach often improve within the first one to two months. Sustained follower growth, traffic and lead generation typically build over three to six months.",
            },
        ],
    },
];


const cards = [
    "https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d",
    "https://images.unsplash.com/photo-1492724441997-5dc865305da7",
    "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
    "https://images.unsplash.com/photo-1519389950473-47ba0277781c"
];

const images = [
    "/Images/Services/wolfpackLogo.png",
    "/Images/Services/wolfpackLogo.png",
    "/Images/Services/wolfpackLogo.png",
    "/Images/Services/wolfpackLogo.png",
];





function DetailServicePage() {
    const [selectedMenue, setselectedMenue] = useState("")
    // const [selectedMenueObject, setSelectedMenueObject] = useState([])
    // const navigate = useNavigate()
    const location = useLocation()
    // const { id } = location.state

    // useEffect(() => {
    //     setselectedMenue(servicesData?.[id]?.title)
    //     setSelectedMenueObject(servicesData?.[id]?.title)
    // }, [servicesData, id])

    useEffect(() => {
        setSelectedMenueObject(servicesData?.find((item) => item.title == selectedMenue))
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [selectedMenue])


    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true, // animation happens only once
        });

    }, []);

    const logos = [
        {
            front: "/Images/Services/belong-front.png",
            back: "/Images/Services/belong-back.png",
            value: "belong"
        },
        {
            front: "/Images/Services/betodyssey-front.png",
            back: "/Images/Services/betodyssey-back.png",
            value: "betodyssey"
        },
        {
            front: "/Images/Services/connexion-front.png",
            back: "/Images/Services/connexion-back.png",
            value: "connexion"
        },
        {
            front: "/Images/Services/futsaloz-front.png",
            back: "/Images/Services/futsaloz-back.png",
            value: "futsaloz"
        },
        {
            front: "/Images/Services/juicelabs-front.png",
            back: "/Images/Services/juicelabs-back.png",
            value: "juicelabs"
        },
        {
            front: "/Images/Services/louca-front.png",
            back: "/Images/Services/louca-back.png",
            value: "louca"
        },
        {
            front: "/Images/Services/miromar-front.png",
            back: "/Images/Services/miromar-back.png",
            value: "miromar"
        },
        {
            front: "/Images/Services/mysterymanagement-front.png",
            back: "/Images/Services/mysterymanagement-back.png",
            value: "mysterymanagement"
        },
        {
            front: "/Images/Services/pinch-front.png",
            back: "/Images/Services/pinch-back.png",
            value: "pinch"
        },
        {
            front: "/Images/Services/redarc-front.png",
            back: "/Images/Services/redarc-back.png",
            value: "redarc"
        },
        {
            front: "/Images/Services/sinefa-front.png",
            back: "/Images/Services/sinefa-back.png",
            value: "sinefa"
        },
        {
            front: "/Images/Services/splooed-front.png",
            back: "/Images/Services/splooed-back.png",
            value: "splooed"
        },
        {
            front: "/Images/Services/tandm-front.png",
            back: "/Images/Services/tandm-back.png",
            value: "tandm"
        },
        {
            front: "/Images/Services/wefroth-front.png",
            back: "/Images/Services/wefroth-back.png",
            value: "wefroth"
        },
        {
            front: "/Images/Services/wolfpack-front.png",
            back: "/Images/Services/wolfpack-back.png",
            value: "wolfpack"
        },

    ];

    const [selectedMenueObject, setSelectedMenueObject] = useState(null);

    const navigate = useNavigate();
    const { serviceSlug } = useParams();

    const generateSlug = (title) => {
        return title
            .toLowerCase()
            .replace(/&/g, "")
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, "")
            .replace(/-+/g, "-")
            .replace(/^-|-$/g, "");
    };
    useEffect(() => {
        const selectedService = servicesData.find(
            (item) => item?.navigateurl === serviceSlug
        );
        if (!selectedService) {
            navigate("/404", { replace: true });
            return;
        }

        setSelectedMenueObject(selectedService);

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

    }, [serviceSlug, navigate]);

    // <span className='text-light-main'>Brand</span> <span className='text-color'>Design &</span> <span className='text-light-main'>UI/UX</span>
    return (
        <Box mt={{ xs: 8, md: 4, lg: 5 }}>
            <Grid container spacing={'40px'} alignItems={'start'}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Typography
                        component="h1"
                        variant="h1"
                        sx={{
                            position: 'absolute',
                            width: 1,
                            height: 1,
                            padding: 0,
                            margin: -1,
                            overflow: 'hidden',
                            clip: 'rect(0, 0, 0, 0)',
                            whiteSpace: 'nowrap',
                            border: 0
                        }}
                    >
                        {selectedMenueObject?.showtitle}
                    </Typography>
                    <Typography data-aos="fade-up" className='text-color' variant='h3'>{selectedMenueObject?.title}</Typography>
                    <Typography data-aos="fade-up" className='mt-5 text-grey'>{selectedMenueObject?.overviewLine}</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Typography data-aos="fade-up" className='mt-5 fs-20 text-color'>{selectedMenueObject?.overview}</Typography>
                </Grid>
            </Grid>
            <Box className="marquee-container" mt={{ xs: 2, md: 3, lg: 5 }}>
                <Box className="marquee-track">
                    <Typography variant='h1' className="text-color-main">
                        {selectedMenueObject?.scrollLine}
                    </Typography>
                    {/* <Typography variant='h1' className="text-color-main">
                        How We Approach Brand Design & UI/UX Design for Growing Products ©
                    </Typography> */}
                </Box>
            </Box>
            <Box mt={{ xs: 2, md: 3, lg: 5 }} className='bg-light-main'>
                {selectedMenueObject?.features?.map((item, index) => (
                    <Grid className='p-3 bg-light-main mb-2' borderBottom={'1px solid var(--primary-dark-light-color)'} spacing={{ xs: 2, lg: 20 }} container >
                        <Grid size={{ xs: 12, md: 7 }} >
                            <Typography data-aos="fade-up" className='fs-48 fw-bold text-light-main'>0{index + 1}</Typography>
                            <Typography data-aos="fade-up" maxWidth={{ xs: '400px', md: "600px" }} className='fs-32 fw-bold text-color-main'
                                ml={{ lg: 7 }}>{item?.title}</Typography>
                        </Grid>
                        <Grid size={{ xs: 12, md: 5 }} alignItems={{ xs: "start", md: "end" }} className='d-flex  pb-3'>
                            <Typography data-aos="fade-up" ml={{ xs: 0, md: "auto" }} className='fs-16 text-grey'>{item?.description}</Typography>
                        </Grid>
                    </Grid>
                ))}

            </Box>

            {/* <Grid container spacing={2} mt={{ xs: 2, md: 3, lg: 5 }}>
                <Grid data-aos='zoom-in' size={6}>
                    <Box component={'img'} width={'100%'} src={'/Images/Services/wolfpackLogo.png'}></Box>
                </Grid>
                <Grid data-aos='zoom-in' size={6}>
                    <Box component={'img'} width={'100%'} src={'/Images/Services/wolfpackLogo.png'}></Box>
                </Grid>
                <Grid data-aos='zoom-in' size={6}>
                    <Box component={'img'} width={'100%'} src={'/Images/Services/wolfpackLogo.png'}></Box>
                </Grid>
                <Grid data-aos='zoom-in' size={6}>
                    <Box component={'img'} width={'100%'} src={'/Images/Services/wolfpackLogo.png'}></Box>
                </Grid>
            </Grid> */}
            <Box
                sx={{
                    overflow: "hidden",
                    width: "100%",
                    mt: { xs: 2, md: 3, lg: 5 },
                }}
            >
                <Typography data-aos='fade-up' className='fs-52 mb-4 text-color-main' fontWeight={550}>Our Latest Work</Typography>
                <Box
                    sx={{
                        display: "flex",
                        width: "max-content",
                        animation: "scroll 90s linear infinite",
                        gap: "20px",
                        "&:hover": {
                            animationPlayState: "paused",
                        },
                    }}
                >       <Box gap={'20px'} className='d-flex align-items-center' width={'fit-content'}>
                        {logos?.map((logo, index) => (
                            <Box onClick={() => { navigate(`/client-details/${logo?.value}`); }} key={index} width={'25vw'}>
                                <Box className="flip-card">
                                    <Box className="flip-card-inner">

                                        {/* FRONT */}
                                        <Box className="flip-card-front">
                                            <Box className='border-10' component="img" src={logo.front} width="100%" />
                                        </Box>

                                        {/* BACK */}
                                        <Box className="flip-card-back">
                                            <Box className='border-10' component="img" src={logo.back} width="100%" />
                                        </Box>

                                    </Box>
                                </Box>

                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>

            <Box mt={{ xs: 2, md: 3, lg: 5 }}>
                <Typography data-aos='fade-up' className='fs-52 mb-4 text-color-main' fontWeight={550}>Our Process</Typography>
                {selectedMenueObject?.processes?.map((item, index) => (
                    <Box data-aos='fade-up' key={index} border={'1px solid var(--primary-dark-color)'} className='p-4 mb-3'>
                        <Typography variant='h4' className='text-color-main' gutterBottom>{index + 1}.&nbsp;{item?.title}</Typography>
                        <Typography className='text-grey fs-16'>{item?.discription}</Typography>
                    </Box>
                ))}
            </Box>
            {/* 
            <Grid container mt={{ xs: 2, md: 3, lg: 5 }}>
                <Grid size={{ xs: 12, md: 4, xl: 3 }}>
                    <Typography data-aos='fade-up' className='fs-52 mb-4 text-color-main' fontWeight={550}>Our Latest Brand Design & UI/UX Work</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 8, xl: 9 }}>
                </Grid>
            </Grid> */}


            <Grid container mt={{ xs: 2, md: 3, lg: 5 }}>
                <Grid size={{ xs: 12, md: 4, xl: 3 }}>
                    <Typography data-aos='fade-up' className='fs-52 mb-4 text-color-main' fontWeight={550}>FAQ</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 8, xl: 9 }}>
                    <Services services={selectedMenueObject?.faq} />
                </Grid>
            </Grid>
            {/* <Grid container spacing={2} mt={{ xs: 2, md: 3, lg: 5 }} >
                <Grid size={12}>
                    <Typography className='text-light-main fs-20 text-center' gutterBottom>Our Other Services</Typography>
                </Grid>
                <ToggleButtonGroup
                    value={selectedMenue}
                    exclusive
                    fullWidth
                    onChange={(event, newValue) => {
                        if (newValue !== null) {
                            setselectedMenue(newValue);
                        }
                    }}
                >
                    <Grid container spacing={2} className='w-100'>
                        {servicesData?.map((item) => (
                            <Grid key={item.title} size={{ xs: 12, md: 6, lg: 4 }}>
                                <ToggleButton
                                    value={item.title}
                                    fullWidth
                                    className={`py-2 ${selectedMenue === item.title
                                        ? "text-light"
                                        : "text-color-main"
                                        }`}
                                    sx={{
                                        background:
                                            selectedMenue === item.title
                                                ? "var(--primary-color)"
                                                : "var(--btn-dark-color)",
                                        border: "none",
                                        "&.Mui-selected": {
                                            background: "var(--primary-color) !important",
                                            color: "#fff",
                                        },
                                        "&:hover": {
                                            background: "var(--primary-color)",
                                            color: "#fff",
                                        },
                                    }}
                                >
                                    {item.title}
                                </ToggleButton>
                            </Grid>
                        ))}
                    </Grid>
                </ToggleButtonGroup>

            </Grid> */}
            <Grid container spacing={2} mt={{ xs: 2, md: 3, lg: 5 }}>
                <Grid size={12}>
                    <Typography className='text-light-main fs-20 text-center' gutterBottom>
                        Our Other Services
                    </Typography>
                </Grid>

                <Grid container spacing={2} className='w-100'>
                    {servicesData
                        ?.filter((item) => item.title !== selectedMenueObject?.title)
                        .map((item) => (
                            <Grid key={item.title} size={{ xs: 12, md: 6, lg: 4 }}>
                                <Button
                                    fullWidth
                                    className="py-2 text-color-main"
                                    onClick={() =>
                                        navigate(`/services/${item?.navigateurl}`)
                                    }
                                    sx={{
                                        background: "var(--btn-dark-color)",
                                        border: "none",
                                        "&:hover": {
                                            background: "var(--primary-color)",
                                            color: "#fff",
                                        },
                                    }}
                                >
                                    {item.title}
                                </Button>
                            </Grid>
                        ))}
                </Grid>
            </Grid>

            <Box mt={{ xs: 2, md: 3, lg: 5 }}>
                <LetsTalk />
            </Box>

            <SEO
                title={selectedMenueObject?.metatitle}
                description={selectedMenueObject?.metadescription}
                keywords="App Gallery, discover apps, digital applications"
                canonical="https://appgallery.com.au/"
            />
        </Box>
    )
}

export default DetailServicePage
